/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export const COMPUTED_TYPE_EXPRESSION = "expression";

/* supported types */
export let computationHandlers = {
    [COMPUTED_TYPE_EXPRESSION]: {
        "name": "Expression",
    },
};

export default declareLinkedEntity({
    entity: "computedFieldDefs",
    graphQL: "ComputedFieldDef",
    name: "Computed Field Definition",
    defaultOrder: ['entityDef_id', 'key'],
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "computedFieldDefs",
    defaultTitle: (data) => {
        return data['name'];
    },
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['channelDef'],
    fields: (types) => { return {
        id: {
            name: "Field Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
            isPublic: true,
        },
        description: {
            name: "Description",
            type: "string",
            translatable: true,
            defaultValue: "",
            description: "It is used for rendering filled boxes with data.",
            isPublic: true,
        },
        entityDef: {
            name: "Entity",
            type: "relation",
            to: () => types['entityDefs'],
            defaultValue: (entityDef) => {
                return entityDef['entityDef_id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        fieldEntityDef: {
            name: "Entity",
            type: "relation",
            to: () => types['entityDefs'],
            defaultValue: (entityDef) => {
                return entityDef['entityDef_id'];
            },
            required: true,
        },
        fieldDef: {
            name: "Field",
            type: "relation",
            to: () => types['fieldDefs'],
            defaultValue: (entityDef) => {
                return entityDef['id'];
            },
            required: true,
            relativeTo: ['fieldEntityDef'],
        },
        requiredFields: {
            name: "Required Fields",
            type: "expression",
        },
        type: {
            name: "Type",
            type: "enum",
            defaultValue: "string",
            values: computationHandlers,
        },
        defaultExpression: {
            name: "Default expression",
            type: "expression",
            visibility: (data) => { return data['type'] === COMPUTED_TYPE_EXPRESSION; }
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
});
